export const CANVAS = {
  GRID_SIZE: 40,
  SCALE_MIN: 0.1,
  SCALE_MAX: 5,
  DEFAULT_VIEWPORT: { x: 0, y: 0, scale: 1 },
} as const;

export const LAYER_PALETTE = [
  '#10b981',
  '#f59e0b',
  '#ec4899',
  '#8b5cf6',
  '#06b6d4',
  '#f97316',
  '#ef4444',
] as const;
